var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMore24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_more",
    transform: "translate(-5.5 -11.089)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(5.5 11.089)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(12.5 11.089)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(19.5 11.089)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMore24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_more24x24.e3f56b9a8a319a9bfe456d584f3b6942.svg";